<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import EditModal from "./EditModal.vue";
    import { DragScroll } from "./dragScroll";
    enum workStatus {
        none = 0,
        inputFocus = 1,
    }
    @Component({
        components: {
            EditModal,
        },
    })
    export default class SeriesModal extends Vue {
        defaultPosition = {
            left: 180,
            top: 208,
        };
        @Prop()
        dataset;
        @Prop()
        colorList;

        handleClose() {
            this.$emit("closeEvent");
        }
        fillStr = "%edrawNull%";
        borderRight = 1;
        xOffset = 1;
        yOffset = 1;
        minColumn = 6;
        minRow = 6;
        tempData = null;
        inputStr = null;
        inputEl = null;
        blockEl = null;
        selectEl = null;
        inputX = 0;
        inputY = 0;
        datasetBox = null;
        tbExcelBody = null;
        canEdit = false;
        isMac() {
            return /macintosh|mac os x/i.test(navigator.userAgent);
        }
        inputStatus = workStatus.none;
        setStatus(status: workStatus) {
            this.inputStatus = status;
        }
        indexToPx(xIndex: number, yIndex: number) {
            let tbData = this.tbExcelBody.children;
            let target = tbData[yIndex + this.yOffset].children[xIndex + this.xOffset];

            let child = target.getBoundingClientRect(),
                parent = this.datasetBox.getBoundingClientRect(),
                scrollT = this.datasetBox.scrollTop,
                scrollL = this.datasetBox.scrollLeft;
            return {
                x: child.left - parent.left + scrollL,
                y: child.top - parent.top + scrollT,
                w: child.width,
                h: child.height,
            };
        }
        pxToIndex(x: number, y: number) {
            let tbData = this.tbExcelBody.children,
                parent = this.datasetBox.getBoundingClientRect(),
                scrollT = this.datasetBox.scrollTop,
                scrollL = this.datasetBox.scrollLeft;
            let xIndex = -1,
                yIndex = -1;
            for (let i = this.yOffset; i < tbData.length; i++) {
                const boxTop = tbData[i].offsetTop,
                    boxHeight = tbData[i].clientHeight,
                    clickTop = y - parent.top + scrollT;
                if (boxTop <= clickTop && boxTop + boxHeight >= clickTop) {
                    yIndex = i - this.yOffset;
                    break;
                }
            }
            if (yIndex != -1) {
                let xArr = tbData[yIndex].children;
                for (let i = 0; i < xArr.length; i++) {
                    const boxLeft = xArr[i].offsetLeft,
                        boxWidth = xArr[i].clientWidth,
                        clickLeft = x - parent.left + scrollL;
                    if (boxLeft <= clickLeft && boxLeft + boxWidth >= clickLeft) {
                        xIndex = i - this.xOffset;
                        break;
                    }
                }
            }
            return {
                xIndex,
                yIndex,
            };
        }
        selectRectData = {
            x1: -1,
            y1: -1,
            x2: -1,
            y2: -1,
        };
        setSelectRect(x1 = 0, y1 = 0, x2 = 0, y2 = 0) {
            if (x1 > x2) {
                [x1, x2] = [x2, x1];
            }
            if (y1 > y2) {
                [y1, y2] = [y2, y1];
            }
            this.selectRectData.x1 = x1;
            this.selectRectData.x2 = x2;
            this.selectRectData.y1 = y1;
            this.selectRectData.y2 = y2;
        }
        calculateSize(x1: number, y1: number, x2: number, y2: number) {
            if ([x1, x2, y1, y2].includes(-1)) return null;
            if (x1 > x2) {
                [x1, x2] = [x2, x1];
            }
            if (y1 > y2) {
                [y1, y2] = [y2, y1];
            }
            let tbData = this.tbExcelBody.children;
            let width = 0,
                height = 0;
            for (let i = y1; i <= y2; i++) {
                height += tbData[i].clientHeight;
            }
            for (let i = x1; i <= x2; i++) {
                width += tbData[i].children[i + 1].clientWidth + this.borderRight;
            }
            this.selectRectData.x1 = x1;
            this.selectRectData.y1 = y1;
            this.selectRectData.x2 = x2;
            this.selectRectData.y2 = y2;
            let { x, y } = this.indexToPx(x1, y1);
            return {
                x,
                y,
                w: width,
                h: height,
            };
        }
        mousedownCell(e: MouseEvent, xIndex: number, yIndex: number) {
            this.scroller.bindWatch();
            this.scroller.updateScrollDomData({
                top: this.datasetBox.getBoundingClientRect()["y"],
                height: this.datasetBox.getBoundingClientRect()["height"],
                scrollTop: this.datasetBox.scrollTop,
                scrollHeight: this.datasetBox.scrollHeight,
            });
            if (e.shiftKey) {
                this.setRectPosition2(this.selectRectData.x1, this.selectRectData.y1, xIndex, yIndex);
            } else {
                this.setRectPosition(xIndex, yIndex);
            }
            const updateScrollTop = () => {
                this.scroller.updateScrollDomData({
                    scrollTop: this.datasetBox.scrollTop,
                });
            };
            this.datasetBox.addEventListener("scroll", updateScrollTop);
            document.onmousemove = (ev: MouseEvent) => {
                let { xIndex: xIndex2, yIndex: yIndex2 } = this.pxToIndex(ev.pageX, ev.pageY);
                this.setRectPosition2(xIndex, yIndex, xIndex2, yIndex2);
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
                this.scroller.removeWatch();
                this.datasetBox.removeEventListener("scroll", updateScrollTop);
            };
        }
        dblClickCell() {
            this.canEdit = true;
            this.focusInput(true);
        }
        setRectPosition(xIndex: number, yIndex: number) {
            let obj = this.indexToPx(xIndex, yIndex);
            this.setSelectRect(xIndex, yIndex, xIndex, yIndex);
            this.selectEl.style = `left: ${obj.x}px;top: ${obj.y}px;width: ${obj.w}px;height: ${obj.h}px`;
            this.setInputPosition(xIndex, yIndex);
        }
        setRectPosition2(xIndex: number, yIndex: number, xIndex2: number, yIndex2: number) {
            let obj = this.calculateSize(xIndex, yIndex, xIndex2, yIndex2);
            if (obj != null) {
                this.setSelectRect(xIndex, yIndex, xIndex2, yIndex2);
                this.setInputPosition(xIndex2, yIndex2);
                this.selectEl.style = `left: ${obj.x}px;top: ${obj.y}px;width: ${obj.w}px;height: ${obj.h}px`;
            }
        }
        setInputPosition(xIndex: number, yIndex: number) {
            this.blurInput();
            this.inputX = xIndex;
            this.inputY = yIndex;
            let data = this.tempData[yIndex] ? this.tempData[yIndex][xIndex] : "";
            if (data == this.fillStr) {
                data = "";
            }
            this.inputStr = data;
            let obj = this.indexToPx(xIndex, yIndex);
            this.blockEl.style = `left: ${obj.x}px;top: ${obj.y}px;width: ${obj.w - 1}px;height: ${obj.h}px`;
        }
        hiddenInput() {
            this.blockEl.style = `left: ${-100}px;top:${-100}px`;
        }
        focusInput(moveCursors = false) {
            if (moveCursors) {
                const temp = this.inputEl.value;
                this.inputEl.value = "";
                this.inputEl.value = temp;
                this.inputEl.select();
            }
            this.inputEl.focus();
            this.setStatus(workStatus.inputFocus);
        }
        blurInput() {
            this.inputEl.blur();
            this.setStatus(workStatus.none);
        }
        initCellPosition(xIndex: number, yIndex: number) {
            this.setInputPosition(xIndex, yIndex);
            // focusInput()
        }

        autoExpand() {
            let arr = JSON.parse(JSON.stringify(this.tempData));
            if (arr.length - 1 == this.inputY) {
                let temp = new Array(arr[0].length).fill(this.fillStr);
                arr.push(temp);
            }
            const firstLineData = arr[0];
            if (![this.fillStr, ""].includes(firstLineData[firstLineData.length - 1])) {
                let expandLength = firstLineData.length + 1;
                for (let i = 0; i < arr.length; i++) {
                    let startIndex = arr[i].length;
                    arr[i].length = expandLength;
                    arr[i].fill(this.fillStr, startIndex);
                }
            }
            this.tempData = arr;
        }
        expandRow(num: number) {
            // 增加指定数目行
            let arr = JSON.parse(JSON.stringify(this.tempData));
            for (let i = 0; i < num; i++) {
                let temp = new Array(arr[0].length).fill(this.fillStr);
                arr.push(temp);
            }
            this.tempData = arr;
        }
        expandCol(num: number) {
            // 增加指定数目列
            let arr = JSON.parse(JSON.stringify(this.tempData));
            for (let i = 0; i < arr.length; i++) {
                let len = arr[i].length;
                arr[i].length = len + num;
                arr[i].fill(this.fillStr, len);
            }
            this.tempData = arr;
        }
        shakeEmpty() {
            let arr = JSON.parse(JSON.stringify(this.tempData));
            const isNull = (arr: Array<string>) => {
                return arr.every((value: string) => [this.fillStr, ""].includes(value));
            };
            if (arr.length <= this.minRow && arr[0].length <= this.minColumn) {
                return;
            }
            if (arr.length > this.minRow && isNull(arr[arr.length - 1]) && isNull(arr[arr.length - 2])) {
                // 删除空余行
                arr.pop();
            }
            let rowLength = arr[0].length;
            let tempList = [],
                tempList2 = [];
            tempList.push(arr[0][rowLength - 1] || "");
            tempList2.push(arr[0][rowLength - 2] || "");
            if (arr[0].length > this.minColumn && isNull(tempList2) && isNull(tempList)) {
                for (let item of arr) {
                    item.pop();
                }
            }
            this.tempData = arr;
        }
        setCellData() {
            this.tempData[this.inputY][this.inputX] = this.inputStr;
            this.hiddenInput();
            this.autoExpand();
            this.shakeEmpty();
            this.uploadData();
            this.canEdit = false;
        }
        uploadData() {
            let temp = JSON.parse(JSON.stringify(this.tempData));
            for (let i = temp.length - 1; i >= 0; i--) {
                let item = temp[i];
                temp[i] = item.filter((data: string) => `${data}` != "%edrawNull%");
                if (temp[i].length == 0) {
                    temp.splice(i, 1);
                }
            }
            this.$emit("changeDataset", temp);
        }
        get firstLineNum() {
            if (this.tempData && this.tempData[0]) return this.tempData[0].length;
            else return 0;
        }
        setTHeadName(item: number) {
            // 返回 A AA AAA
            let temp = item,
                percentile = 0,
                tenth = 0;
            while (temp > 18278) {
                // 超出zzz
                alert("数据过大");
                return;
            }
            while (temp > 702) {
                temp -= 676;
                percentile++;
            }
            while (temp > 26) {
                temp -= 26;
                tenth++;
            }
            if (percentile != 0) {
                return String.fromCharCode(percentile + 64) + String.fromCharCode(tenth + 64) + String.fromCharCode(temp + 64);
            } else if (tenth != 0) {
                return String.fromCharCode(tenth + 64) + String.fromCharCode(temp + 64);
            } else {
                return String.fromCharCode(item + 64);
            }
        }
        handleKeypress(e: KeyboardEvent) {
            let code = e.keyCode;
            let ctrlKey = navigator.userAgent.indexOf("Mac") > 0 ? e.metaKey : e.ctrlKey;
            if (code == 13) {
                this.blurInput();
            }
            if (this.inputStatus !== workStatus.inputFocus && ctrlKey) {
                return;
            }
            if (code == 46 || (this.isMac && code == 8)) {
                // delete
                this.handleDelet();
                return;
            }
            if (
                (this.inputStatus !== workStatus.inputFocus && code > 47 && code < 58) ||
                (code > 64 && code < 91) ||
                (code > 96 && code < 110) ||
                code == 229
            ) {
                // 229为输入法
                this.focusInput();
            }
            switch (code) {
                case 37: {
                    // 左
                    let xIndex = this.inputX - 1 < 0 ? 0 : this.inputX - 1;
                    this.setRectPosition(xIndex, this.inputY);
                    this.selectEl.scrollIntoViewIfNeeded();
                    break;
                }
                case 38: {
                    // 上
                    let yIndex = this.inputY - 1 < 0 ? 0 : this.inputY - 1;
                    this.setRectPosition(this.inputX, yIndex);
                    this.selectEl.scrollIntoViewIfNeeded();
                    break;
                }
                case 39: {
                    // 右
                    let xIndex = this.inputX + 1 > this.firstLineNum - 1 ? this.firstLineNum - 1 : this.inputX + 1;
                    this.setRectPosition(xIndex, this.inputY);
                    this.selectEl.scrollIntoViewIfNeeded();
                    break;
                }
                case 40: {
                    // 下
                    let yIndex = this.inputY + 1 > this.tempData.length - 1 ? this.tempData.length - 1 : this.inputY + 1;
                    this.setRectPosition(this.inputX, yIndex);
                    this.selectEl.scrollIntoViewIfNeeded();
                    break;
                }
            }
        }
        handleCopy(event: ClipboardEvent) {
            let arr: any = [];
            for (let i = this.selectRectData.y1; i <= this.selectRectData.y2; i++) {
                let temp: any = [];
                for (let j = this.selectRectData.x1; j <= this.selectRectData.x2; j++) {
                    temp.push(this.tempData[i][j]);
                }
                arr.push(temp);
            }

            // 剪贴板操作
            let tempCopyData = arr.slice(0);
            let testdata = tempCopyData.reduce((a: any, b: any) => {
                return a.concat(b.join("\t"));
            }, []);
            let asdasd = testdata.join("\r\n");
            event.preventDefault();
            event.clipboardData!.setData("text", asdasd);
        }
        handlePaste(event: ClipboardEvent) {
            let pastestr = event.clipboardData!.getData("text");
            if (pastestr) {
                // 剪贴板有数据
                let len = pastestr.split("\n");
                if (len[len.length - 1] == "") {
                    // excel复制过来的数据，去除最后的空行
                    len.pop();
                }
                let pasteData = len.reduce((a: any, b: any) => {
                    let temp = b.replace(/[\r\n]/g, "").split(/\t/);
                    a.push(temp);
                    return a;
                }, []);
                if (pasteData.length != 0) {
                    let arr = JSON.parse(JSON.stringify(this.tempData));
                    let isExpand = false;
                    let startX = this.inputX,
                        startY = this.inputY;
                    // 判断是否需要扩展表格
                    if (startY + pasteData.length > arr.length) {
                        isExpand = true;
                        this.expandRow(startY + pasteData.length - arr.length);
                    }
                    if (startX + pasteData[0].length > arr[0].length) {
                        isExpand = true;
                        this.expandCol(startX + pasteData[0].length - arr[0].length);
                    }
                    isExpand && (arr = JSON.parse(JSON.stringify(this.tempData)));

                    for (let i = startY; i < startY + pasteData.length; i++) {
                        for (let j = startX; j < startX + pasteData[0].length; j++) {
                            arr[i][j] = pasteData[i - startY][j - startX];
                        }
                    }
                    this.tempData = arr;

                    this.setInputPosition(startX, startY); // 更新input值
                    this.uploadData();
                }
            }
        }
        handleCut = (event: ClipboardEvent) => {};

        handleDelet() {
            for (let i = this.selectRectData.y1; i <= this.selectRectData.y2; i++) {
                for (let j = this.selectRectData.x1; j <= this.selectRectData.x2; j++) {
                    this.tempData[i][j] = "";
                }
            }
            this.hiddenInput();
            this.autoExpand();
            this.shakeEmpty();
            this.uploadData();
        }

        initRef() {
            this.scroller = this.$refs.scroller;
            this.inputEl = this.$refs.inputEl;
            this.blockEl = this.$refs.blockEl;
            this.selectEl = this.$refs.selectEl;
            this.datasetBox = this.$refs.datasetBox;
            this.tbExcelBody = this.$refs.tbExcelBody;
        }
        scroller = null;
        mounted() {
            this.initRef();
            document.addEventListener("keydown", this.handleKeypress);
            document.addEventListener("copy", this.handleCopy);
            document.addEventListener("paste", this.handlePaste);
            document.addEventListener("cut", this.handleCut);
            let arr = JSON.parse(JSON.stringify(this.dataset));
            let xLength = 0;
            if (arr[0]?.length <= this.minColumn - 1) {
                let startIndex = arr[0].length;
                arr[0].length = this.minColumn;
                xLength = this.minColumn;
                arr[0].fill(this.fillStr, startIndex);
            } else {
                arr[0].length = arr[0].length + 1;
                xLength = arr[0].length;
                arr[0][arr[0].length - 1] = this.fillStr;
            }
            if (arr.length > this.minRow) {
                let temp = new Array(arr[0].length).fill(this.fillStr);
                arr.push(temp);
            } else {
                while (arr.length <= this.minRow) {
                    let temp = new Array(arr[0].length).fill(this.fillStr);
                    arr.push(temp);
                }
            }
            for (let i = 1; i < arr.length - 1; i++) {
                let startIndex = arr[i].length;
                arr[i].length = xLength;
                arr[i].fill(this.fillStr, startIndex);
            }
            this.tempData = arr;
            this.$nextTick(() => {
                this.initCellPosition(0, 0);
            });
            this.scroller = new DragScroll(this.datasetBox);
        }
        beforeDestroy() {
            document.removeEventListener("keydown", this.handleKeypress);
            document.removeEventListener("copy", this.handleCopy);
            document.removeEventListener("paste", this.handlePaste);
            document.removeEventListener("cut", this.handleCut);
        }
    }
</script>

<template>
    <EditModal :title="$t('title')" :width="400" :position="defaultPosition" @closeEvent="handleClose">
        <div class="dataset-box" ref="datasetBox" @scroll="hiddenInput">
            <table id="tbExcel" class="tb-excel" border="0" cellspacing="0" cellpadding="0">
                <tbody ref="tbExcelBody">
                    <tr>
                        <th></th>
                        <td class="tb-tablehead" v-for="(item, index) in firstLineNum" :key="index">
                            {{ setTHeadName(item) }}
                            <span v-if="colorList[index]" class="tb-tablehead-color" :style="{ background: colorList[index].color }"></span>
                        </td>
                    </tr>
                    <tr v-for="(yItem, yindex) in tempData" :key="yindex">
                        <th>{{ yindex + 1 }}</th>
                        <td
                            v-for="(xItem, xindex) in yItem"
                            :key="xindex"
                            @mousedown="mousedownCell($event, xindex, yindex)"
                            @dblclick="dblClickCell"
                        >
                            <p v-if="tempData[yindex] && tempData[yindex][xindex] != '%edrawNull%'">
                                {{ tempData[yindex][xindex] }}
                            </p>
                            <p v-else></p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div ref="blockEl" class="float-input" :class="{ 'ban-edit': !canEdit }">
                <input ref="inputEl" type="text" v-model="inputStr" @blur="setCellData" />
            </div>
            <div ref="selectEl" class="select-rect"></div>
        </div>
    </EditModal>
</template>

<style lang="stylus" scoped>
    .dataset-box
        position relative
        width 100%
        height 174px
        overflow overlay
        &::-webkit-scrollbar
            width 6px
            height 6px

        &::-webkit-scrollbar-thumb
            border-radius 6px
            background rgba(255,255,255,0.3)

        &::-webkit-scrollbar-track
            width 6px
            border-radius 8px

        &::-webkit-scrollbar-corner
            background none
        .tb-excel
            color #fff
            font-size 12px
            tr
                white-space nowrap
                &:first-child
                    th,td
                        border-top 1px solid #3C3C3C
            td:not(.tb-tablehead):hover
                background rgba(60, 60, 60, 1)
            th,td
                display inline-block
                text-align center
                width 56px
                height 24px
                line-height 24px
                border-right 1px solid #3C3C3C
                border-bottom 1px solid #3C3C3C
            th
                border-left 1px solid #3C3C3C
            p
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
            .tb-tablehead
                .tb-tablehead-color
                    display inline-block
                    border-radius 50%
                    width 10px
                    height 10px
        .float-input
            display flex
            position absolute
            left -100px
            top -100px
            width 56px
            height 23px
            background #191919
            border 1px solid var(--themeColor)
            &.ban-edit
                pointer-events none
            input
                width 100%
                height 22px
                line-height 22px
                font-size 12px
                text-align center
                color #fff
                background #191919
                outline none
                border none
                padding 0
                margin 0
        .select-rect
            position absolute
            left -100px
            top -100px
            border 2px solid var(--themeColor)
            pointer-events none
</style>
<i18n>
{
    "zh" : {
        "title": "编辑数据"
    },
    "en": {
        "title": "Edit Data"
    },
    "de" : {
        "title": "Daten bearbeiten"
    },
    "es" : {
        "title": "Editar datos"
    },
    "fr" : {
        "title": "Modifier les données"
    },
    "id" : {
        "title": "Edit Data"
    },
    "it" : {
        "title": "Modifica dati"
    },
    "jp" : {
        "title": "データを編集"
    },
    "kr" : {
        "title": "데이터 편집"
    },
    "pt" : {
        "title": "Editar dados"
    },
    "tw" : {
        "title": "編輯資料"
    }
}
</i18n>
